// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3zHQL","label":"Category_label__5iQjK","content":"Category_content__14XB-","header":"Category_header__36dbj","location":"Category_location__nJ3Ba"};